@use "../../scss/colors";
@use "../../scss/font";
@use "../../scss/mixins";

.PerformanceTrackingTile {
  height: 100%;

  &__tileHeader {
    display: flex;
    flex-direction: row;
    column-gap: 0.5rem;
    align-items: center;

    .icon-checkCircle--md {
      align-self: flex-start;
    }

    h2 {
      color: colors.$amway_black;
      font-size: font.$size--large;
      font-style: normal;
      font-weight: font.$weight--bold;
      line-height: 1.75rem;
      margin: 0;
      padding: 0;
      min-height: 3.5rem;
      margin-bottom: 1rem;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex: 1;
    justify-content: center;
  }

  &__block {
    position: relative;
    display: flex;
    height: 5rem;
    border-radius: 0.75rem;
    border: 1px solid colors.$light_gray;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 3.5rem;

    &--loader {
      flex-direction: column;
    }

    &Content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      flex: 1;
    }

    &--icon {
      position: absolute;
      right: 0.8rem;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &--title {
      color: colors.$dark_grey_on_white;
      font-size: font.$size--medium;
      font-weight: font.$weight--medium;
    }

    &--value {
      display: flex;
      gap: 0.25rem;
      align-items: center;
      color: colors.$amway_black;
      font-size: font.$size--large;
      font-weight: font.$weight--bold;
      line-height: 1.75rem;
      justify-content: center;

      .icon-alert {
        scale: 1;
      }
    }
  }

  &__trackingBlock {
    &--green {
      background-color: colors.$light_green_8;
      border-color: colors.$green_outline;
    }

    &--yellow {
      background-color: colors.$extra_light_orange;
      border-color: colors.$outline_orange;
    }

    &--red {
      background-color: colors.$background_light_red;
      border-color: colors.$hover_error_red;
    }
  }

  &__footnote {
    margin-top: 0.4rem;
    padding-left: 1.4rem;
    font-size: font.$size--medium;
    font-weight: font.$weight--medium;
  }
}
